import React, { useRef } from 'react'

import { useUserMenuItems } from 'features/user/ui/UserMenu'
import { AppLogo } from 'shared/components/AppLogo'
import { Avatar, Breadcrumb, Button, Dropdown, UserOutlined } from 'shared/ui'
import styled from 'styled-components'

import { useGetEnablePermission } from '../hooks/useGetEnablePermission'

type TopSectionProps = {
  isAuth: boolean
  onUpload: (files: FileList) => void
  breadcrumbs: { name: string; id?: string, onClick?: () => void }[]
  onAuthClick?: () => void
  onCreateAccountClick?: () => void
}

export const TopSection: React.FC<TopSectionProps> = ({
  isAuth,
  onUpload,
  breadcrumbs,
  onAuthClick,
  onCreateAccountClick,
}) => {
  const hiddenFileInputRef = useRef<HTMLInputElement>(null)
  const menuItems = useUserMenuItems(true)
  const { isUploadEnabled, isEditContentEnabled } = useGetEnablePermission()
  const isUploadOrEditEnabled = isUploadEnabled || isEditContentEnabled


  const handleUploadClick = () => {
    hiddenFileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length) {
      onUpload(event.target.files)
    }
  }

  return (
    <TopWrapper>
      <HeaderRow>
        <AppLogo
          width={100}
          alt="Company Logo"
        />

        <Breadcrumb>
          {breadcrumbs
            .filter((crumb) => !(crumb.name === 'All files' && breadcrumbs.length === 1))
            .map((crumb, index) => (
              <Breadcrumb.Item key={index}>
                <span
                  onClick={crumb.onClick}
                  style={{ cursor: crumb.onClick ? 'pointer' : 'default' }}
                >
                  {crumb.name}
                </span>
              </Breadcrumb.Item>
            ))}
        </Breadcrumb>

        {!isAuth && (
          <STopSectionRight>
            <Button
              size='middle'
              variant="outlined"
              onClick={onAuthClick}
            >
              Log In
            </Button>

            <Button
              type="primary"
              size='middle'
              onClick={onCreateAccountClick}
            >
              Create account
            </Button>

            {(isUploadOrEditEnabled) && (
              <Button
                type="primary"
                size='middle'
                onClick={handleUploadClick}
              >
                Upload
              </Button>
            )}
          </STopSectionRight>

        )}

        {isAuth && (
          <STopSectionRight>
            {(isUploadOrEditEnabled) && (
              <Button
                type="primary"
                size='middle'
                onClick={handleUploadClick}
              >
                Upload
              </Button>
            )}

            <Dropdown menu={{ items: menuItems }}
              trigger={['click']}
            >
              <SUserAvatar icon={<UserOutlined />} />
            </Dropdown>
          </STopSectionRight>
        )}
      </HeaderRow>

      <input
        type="file"
        multiple
        ref={hiddenFileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </TopWrapper>
  )
}

const TopWrapper = styled.div`
  margin-bottom: 40px;
`

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
`

const STopSectionRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
`

const SUserAvatar = styled(Avatar)`
  background-color: #0000000F;
  cursor: pointer;
  min-width: 32px;
  color: #000000E0;
`
